/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, object } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { useSelector } from 'react-redux';
import OfferDropdownDesign from './OfferDropdownDesign';
import MarkdownText from './Partials/MarkdownText';
import useOfferGatewayClickHandler from '../../../GraphqlCommonComponents/GenericDialog/OfferGateway/useOfferGatewayClickHandler';
import useClickStreamCustomEventsTracking from '../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import WithImageDesign from './WithImageDesign';
import WithRightIcon from './WithRightIcon';
import { getPageType } from '../../../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles((theme) => ({
    root: (styles) => ({
        border: '1px solid transparent',
        borderImage: 'repeating-linear-gradient(45deg, #D9D9D9 0 5px, transparent 5px 10px) 1',
        borderImageSlice: 1,
        borderRadius: '6px',
        padding: '8px',
        '& > div': {
            background: '#f3e7f4',
            borderRadius: '4px',
            padding: '10px',
        },
    }),
    container: (styles) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: styles?.height || '76px',

    }),
    lockContainer: {
        padding: '10px',
        backgroundColor: '#D9D9D9',
        borderRadius: '50%',
        '& > div': {
            padding: '14px 16px',
            backgroundColor: 'white',
            borderRadius: ' 50%',
        },
    },
    text: {
        margin: '8px 0',
    },
    marginTop: {
        marginTop: '28px',
    },
}));

const OfferGatewayDesign = ({
    offer, notFirst,
}) => {
    const structure = offer?.content?.structure || [];
    const offerGatewayLocked = structure.find((item) => item.offer_gateway_locked)?.offer_gateway_locked ?? null;
    const dropdown = structure.find((item) => item.dropdown)?.dropdown ?? null;
    const campaignPayload = offer?.campaign?.campaignResponses?.[0]?.payload || {};
    const isOfferUnlocked = campaignPayload?.offerFlow === 'Offer Unlocked';
    const subHeading = offerGatewayLocked?.sub_heading;
    const designType = offer?.content?.design_type;
    const pageType = useSelector(getPageType);

    const trackClickThrough = useClickStreamCustomEventsTracking({
        salesforceResponse: offer,
        isFireImpression: true,
        page: { type: pageType || 'home' },
    });

    const classes = useStyles({
        backgroundColor: offerGatewayLocked?.background_color?.color,
        height: offerGatewayLocked?.height,
    });

    const { handleOfferInboxClick } = useOfferGatewayClickHandler(offer);

    const clickHandler = (e) => {
        e.preventDefault();
        handleOfferInboxClick();
        trackClickThrough();
    };

    if (!isOfferUnlocked) {
        if (offerGatewayLocked) {
            return (
                <>
                    <div className={`${classes.root} ${notFirst ? classes.marginTop : ''}`}>
                        <div>
                            {subHeading?.copy && (
                                <MarkdownText data={subHeading} handleClick={clickHandler} />
                            )}
                            <div className={classes.container}>
                                <div className={classes.lockContainer}>
                                    <div>
                                        <img src={offerGatewayLocked?.icon?.url} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
    }

    if (designType === 'with-image') {
        return <WithImageDesign offer={offer} notFirst={notFirst} trackClickThrough={trackClickThrough} />;
    }

    if (dropdown) {
        return <OfferDropdownDesign data={dropdown} notFirst={notFirst} />;
    }

    if (designType === 'with-right-icon') {
        return <WithRightIcon offer={offer} notFirst={notFirst} trackClickThrough={trackClickThrough} />;
    }

    return null;
};

OfferGatewayDesign.propTypes = {
    offer: object,
    notFirst: bool,
};

OfferGatewayDesign.defaultProps = {
    offer: {},
    notFirst: false,
};

export default OfferGatewayDesign;
